/**
 * Utilit\u00e1rio para persist\u00eancia criptografada no localStorage
 * Usa AES para criptografar dados sens\u00edveis do checkout
 */

const CryptoJS = require("crypto-js");

// Chave de criptografia do .env
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || process.env.REACT_APP_JWT_SALT || 'cda802b3fecb8571fb81b73831b551249';

/**
 * Criptografa e salva dados no localStorage
 */
export function saveEncrypted<T>(key: string, data: T): void {
  try {
    const jsonString = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonString, ENCRYPTION_KEY).toString();
    localStorage.setItem(key, encrypted);
  } catch (error) {
    console.error(`[EncryptedStorage] Erro ao salvar ${key}:`, error);
  }
}

/**
 * L\u00ea e descriptografa dados do localStorage
 */
export function loadEncrypted<T>(key: string): T | null {
  try {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;

    const decrypted = CryptoJS.AES.decrypt(encrypted, ENCRYPTION_KEY);
    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
    
    if (!jsonString) {
      console.warn(`[EncryptedStorage] Falha ao descriptografar ${key}`);
      return null;
    }

    return JSON.parse(jsonString) as T;
  } catch (error) {
    console.error(`[EncryptedStorage] Erro ao carregar ${key}:`, error);
    return null;
  }
}

/**
 * Remove dados do localStorage
 */
export function removeEncrypted(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`[EncryptedStorage] Erro ao remover ${key}:`, error);
  }
}

/**
 * Limpa todos os dados criptografados do checkout
 */
export function clearCheckoutStorage(): void {
  const keys = [
    'checkout_cart',
    'checkout_customer',
    'checkout_payment',
    'checkout_discount',
    'checkout_metadata',
  ];
  
  keys.forEach(key => removeEncrypted(key));
}
